// extracted by mini-css-extract-plugin
export default {"root":"root--aeee7e7","error":"error--8035c49"};